export default __webpack_public_path__ + "static/remix-hover-dark-ae978fee31bb82a80ac785fc1ea4244f2f92110b1f663215070d45d356e264da.png";